var styleDataHash = "e0b52f13";
const injectCss = () => {
  var css = `.P4mjt,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._62X-D{color:var(--ricos-custom-p-color,unset);color:var(--ricos-custom-p-color,var(--ricos-text-color,#212121));line-height:21px;font:inherit;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-size:14px;font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);position:inherit;resize:none;text-decoration:var(--ricos-custom-p-text-decoration,unset);width:100%;z-index:1}[dir] ._62X-D{border:none}[dir] ._62X-D>span>a,[dir] ._62X-D>span>span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:640px){._62X-D{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 640px){._62X-D{font-size:var(--ricos-custom-p-font-size,unset)}}[dir] ._62X-D[readonly]{cursor:pointer}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var in_plugin_input_default = {
  "fontElementMap": "P4mjt",
  "inPluginInput": "_62X-D"
};
export {
  in_plugin_input_default as default,
  injectCss
};
//# sourceMappingURL=in-plugin-input-scss.js.map
